module.exports = __webpack_public_path__ + "static/Participate-1c18c043c296d6bbc9f98298afdb1659.png";